import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { AuthContextProvider } from 'context/AuthContext';
import { NotificationContextProvider } from 'context/NotificationContext';
import * as serviceWorker from './serviceWorker';
import App from './App';
import theme from './theme';

import './index.scss';

require('dotenv').config();

ReactDOM.render(
  <AuthContextProvider>
    <NotificationContextProvider>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </MuiThemeProvider>
    </NotificationContextProvider>
  </AuthContextProvider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
